'use strict';
angular.module('schoolLinqApp').directive('rcDate', function () {
	return {
		require: ['ngModel', 'queryOption'],
		scope: {
			labelName: '@',
			ngModel: '=',
			queryOption: '=',
		},
		replace: true,
		restrict: 'E',
		template: require('@ajs/templates/reports/rcDate.html'),
		controller: [
			'$scope',
			function ($scope) {
				$scope.queryOptions = [
					{
						displayName: 'is > or =',
						query: 'greaterthanorequal',
					},
					{
						displayName: 'is < or =',
						query: 'lessthanorequal',
					},
					{
						displayName: 'is >',
						query: 'greaterthan',
					},
					{
						displayName: 'is <',
						query: 'lessthan',
					},
					{
						displayName: '=',
						query: 'equal',
					},
				];
			},
		],
	};
});
